<template>
    <v-container style="margin-top: 80px;">
        <v-row>
            <v-col cols="12" sm="3" class="py-2">
                <v-btn @click="Regresar()" class="ma-2" color="error">
                    Regresar
                </v-btn>
            </v-col>
            <v-col cols="12" md="12">
                <v-card>
                    <v-card-title>

                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search"
                                      append-icon="mdi-magnify"
                                      label="Buscar"
                                      single-line
                                      hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers"
                                  :items="listado"
                                  item-key="Reporte"
                                  :items-per-page="15"
                                  :loading="show"
                                  :search="search"
                                  loading-text="Cargando... espere un momento"
                                  no-data-text="No hay datos disponibles"
                                  :footer-props="{
                                                  'items-per-page-options': [20, 50, 100],
                                                  'items-per-page-text':'Registros por página'
                                                }"
                                  class="elevation-1">
                        <template v-slot:[`item.nrreporte`]="{item}">
                            <a v-on:click="BuscarReporte(item);">{{ item.nrreporte }}</a>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import servicio from '@/services/Operacion/MisPendientes.service.js';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import ManagerLocalStorage from "@/utils/managerLocalStorage.js";

    export default {
        data() {
            return {
                headers: [
                    { text: 'Reporte', value: 'nrreporte', class: "text title" },
                    { text: 'Núm. Siniestro', value: 'svnumsin', class: "text title" },
                    { text: 'Asistencia', value: 'ainombre', class: "text title" },
                    { text: 'Asegurado', value: 'asnombre', class: "text title" },
                    { text: 'Poliza', value: 'dapoliza', class: "text title" },
                    { text: 'Tipo Persona', value: 'saPersona', class: "text title" },
                    { text: 'Fecha del Reporte', value: 'svfhreporte', class: "text title" },
                    { text: 'Fecha de Siniestro', value: 'svfhsiniestro', class: "text title" },
                    { text: 'Fecha de Conclusión', value: 'svfhconclusion', class: "text title" },
                    { text: 'Uslogin', value: 'lduslogin', class: "text title" },
                ],
                show: true,
                listado: [],
                search: '',
            };
        },
        props: ['filtro'],
        computed: {
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            }
        },
        methods: {
            ReportesPendientesAdjuntar() {
                let formdata = new FormData();
                formdata.append("tipo", this.filtro);
                servicio.ReportesPendientesAdjuntar(this, formdata).then(data => {
                    this.listado = data;
                    this.show = false;
                    
                });
            },
            BuscarReporte(item) {
                let aux = item.nrreporte.split('-');
                let _svindice = aux[1];
                let _nrreporte = aux[0];

                let reporte = {
                    nrreporte: _nrreporte,
                    svindice: _svindice,
                    aiclave: item.aiclave,
                    svfhconclusion: item.svfhconclusion
                };
                let routerName = MetodosGenerales.obtenerRouterName(String(item.aiclave));
                MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                this.$router.push({ name: `${routerName}` });
            },
            Regresar() {
                this.$router.push({ name: `MainPendientes`, params: { inifil: this.filtro } });
            },
        },
        mounted() {
            this.ReportesPendientesAdjuntar();
        }
    }
</script>